import React, { useContext } from 'react'
import { Form, Select } from 'semantic-ui-react'
import { RIG_TYPES } from '../../../constants/rigTypes'
import { validRigType } from '../../../types'
import { titleCase } from '../../../utils'
import classNames from '../../../utils/classNames'
import { BookerContext } from '../../../contexts/BookerContext'
import { getTextColorBasedOnBackground } from '../Prerequisites'
import { SiteProps } from '../../../interfaces'

interface ComponentProps {
  userRigType: validRigType
  handleRigTypeChange
  label?: boolean
  fluid?: boolean
  placeholder?: string
  error: string
  setError: (v: string) => void
}

const filterRestrictedRigTypes = (rigTypes: validRigType[], restrictedRigTypes: validRigType[][]) => {
  const restrictedCount = {}

  restrictedRigTypes.forEach((siteRestrictions) => {
    siteRestrictions.forEach((rigType) => {
      restrictedCount[rigType] = (restrictedCount[rigType] || 0) + 1
    })
  })

  const totalSites = restrictedRigTypes.length
  const availableRigTypes = rigTypes.filter((rigType) => restrictedCount[rigType] !== totalSites)

  return availableRigTypes
}

const RigTypeField = ({ userRigType, handleRigTypeChange, label, fluid, placeholder, error, setError }: ComponentProps) => {
  if (label == undefined) label = true

  const { secondaryColor, campingStyle } = useContext(BookerContext)


  const rigTypeOptions = [null]
    .concat(
      filterRestrictedRigTypes(
        Object.values(RIG_TYPES),
        campingStyle.sites.map((site) => site.restricted_rig_types)
      )
    )
    .map((rigType: string) => ({
      key: rigType,
      value: rigType,
      text: titleCase(rigType, true),
    }))
  
  return (
    <Form.Field required>
      {label && (
        <div className='font-bold text-lg mb-1'>
          RV Type
        </div>
      )}
      <div className='flex overflow-x-auto gap-3.5 py-1'>
        {rigTypeOptions
          .filter((option) => option.value)
          .map(({ key, value, text }) => {
            return (
              <div
                style={{
                  borderRadius: 12,
                  borderColor: userRigType === value && secondaryColor,
                  backgroundColor: userRigType === value && secondaryColor,
                  color: userRigType === value && getTextColorBasedOnBackground(secondaryColor),
                }}
                key={key}
                role="button"
                onClick={(e) => {
                  setError('')
                  handleRigTypeChange(e, { value })
                }}
                className={classNames(
                  'p-3 text-sm flex justify-center items-center cursor-pointer whitespace-nowrap border',
                  userRigType === value ? 'text-white' : 'border-gray-300'
                )}
              >
                {text}
              </div>
            )
          })}
      </div>
      {error?.length ? <div className='text-red-600 font-semibold'>{error}</div> : <></>}
    </Form.Field>
  )
}

export default RigTypeField
